export const consultantReportStyles = {
    workspace: 'space-y-5 text-slate-900 [color-scheme:light]',
    panel: 'rounded-2xl border border-slate-200 bg-white p-5 text-slate-900 shadow-sm [color-scheme:light]',
    input: 'mt-2 w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-normal text-slate-900 disabled:opacity-50',
    label: 'block text-sm font-semibold',
    primary: 'rounded-lg bg-blue-700 px-4 py-2 text-sm font-bold text-white hover:bg-blue-800 disabled:opacity-40',
    secondary: 'rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-bold text-slate-900 hover:bg-slate-100 disabled:opacity-40',
    muted: 'text-sm text-slate-500',
    error: 'rounded-lg bg-red-50 p-3 text-sm text-red-800',
};
